import DeploymentConfiguration from './view/components/DeploymentConfiguration';

const DeploymentListView = () => <DeploymentConfiguration />;

export default DeploymentListView;
